  import { Component, OnInit, ElementRef, ViewChild, ViewContainerRef} from '@angular/core';
  import {ActivatedRoute, Router, Params } from '@angular/router';
  import {CartService} from '../services/cart.service';
  import {Cartitems2} from '../classes/cartitems';
  import { MatSidenav, MatSnackBar } from '@angular/material';
 
  import {Observable} from 'rxjs';
import { CommonService } from '../services/common.service';
import { MitterService } from '../services/mitter.service';
import { Meta } from '@angular/platform-browser';
import { AuthService } from '../authentication/auth.service';
import { ProductsService } from '../services/products.service';

  @Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']

  })
  export class HomeComponent implements OnInit {
   timer: any;
   counter = 4;
   searchdata: any;
   stype: any;
   searchterm: any;
    userrole = 9;
    gdata: any;
    gjson: any;
    uid: any;
    uname: any;
    uemail: any;
    umobile: any;
    totalitems = 0;
    data2: Cartitems2[];
     openflag: any;
    userStatus: number;
    loading: any;
    userimg = 'avatar-1577909_960_720.png';
    username = 'User';
    lastorder = [];
    orderitem: any;
    ordercountflag: number;
    ppinventory: any[];
    stockflag: number;
    city_id = 1;
    msg: any;
    action: any;
    cindex: any;
    payable: number;
    quantity: any;
    pid: number;
    tax: number;
    totaldiscount: number;
    discount: number;
    prodprice: number
    prodsku: any;
    prodname: string;
    cquantity = 0;
    citems: number;
    flag = 0;

    constructor(private router: Router, private cartService: CartService,
       private commonService: CommonService, private snackbar: MatSnackBar,
    private authService: AuthService, private mitterService: MitterService,
    private productService: ProductsService, private meta: Meta ) {
      const title = this.meta.getTag('name=title');
      this.meta.removeTagElement(title);
      const description = this.meta.getTag('name=description');
      this.meta.removeTagElement(description);
      this.meta.addTag({ name: 'title', content: 'Online Pet Shop | Pet Care | Pet Resort for your Healthy & Happy Pets' });
      this.meta.addTag({ name: 'description', content: 'Petcart Store - Buy Pet food & treats for Pet Dogs, Cats, Birds & Fish |  Petcart Pulse - Booking Appointments with Vets |  Petcart Nest - Pet Resort with Kennels, Swimming Pool & more' });

        this.timer = setInterval(() => this.timedelay(), 1000);
      }

      ngOnInit() {
    this.loading = true;
        this.getSearchdata();
    }

    timedelay() {
      this.counter = this.counter  - 1;
      if (this.counter === 0) {
        this.checkUserStatus();
        this.checkUserType();
        this.loading = false;
        clearInterval(this.timer);
      }
    }
    checkUserStatus() {
      this.userStatus = this.commonService.checkUserStatus();
      if (this.userStatus == 1) {
        const udata = this.commonService.getUserDataLocally();
        this.uid = udata.uid;
        this.uname = udata .uname;
        this.uemail = udata.uemail;
        this.umobile = udata.umobile;
        this.username = this.uname;

        this.cartService.getUserLastorder(this.uid)
        .subscribe(
          (x) => {
            if (x.length > 0) {
              this.lastorder.push(x[0]);
              this.getOrderItems(this.lastorder[0].orderno)
            }
          });
        this.cartService.getUserCartItems(this.uid)
        .subscribe(
          (data2: Cartitems2[]) => {
            this.data2 = data2;
            this.setCartcount();
          });
         this.cartService.getUserData(this.uemail)
      .subscribe(
        (x) => {
          this.userimg = x[0].image;

        });
      }
     this.commonService.loginsuccess.next(1);

    }
    checkUserType() {
     this.userrole = this.authService.getRoleId();
  }
    setCartcount() {
      let count = 0;
      for (let i = 0; i < this.data2.length; i++) {
        count = count + this.data2[i].quantity;
      }
      this.cartService.changeTotalCartItems(count);
      this.reflect();
    }
    reflect() {
      this.cartService.totalcartitems.subscribe(totalcartitems => {
        this.totalitems = totalcartitems;
      });
    }
    goToOnlineChat() {
      const flag = 3;
      this.commonService.setActivatepath(flag);
      this.router.navigate(['/pulse/onlinedoctors']);
    }
  login() {
    this.router.navigate(['/signin']);
  }
  logout() {
    const flag = 0;
    this.commonService.setActivatepath(flag);
    this.authService.logout();
    this.commonService.setuserStatus();
    this.mitterService.logout();
    this.router.navigate(['/signin']);
  }



  getSearchdata() {
    this.commonService.getProductSearchdata()
    .subscribe (
      (x) => {
        this.searchdata = x;
      });
  }


  goToSearch() {
    const a = typeof this.searchterm;
    if (a === 'object') {
      this.router.navigate(['/store/details/', this.searchterm.id , this.searchterm.url]);
    }else if (this.searchterm == undefined) {
        alert('nothing to search');
      } else if (this.searchterm == '') {
        alert('nothing to search');
      } else {
          this.router.navigate(['/store/search/', 'product', this.searchterm]);
    }
  }
  checkEveryMatch(str, element) {
    if ( str.toString().toLowerCase().match(element)) {
      return 1;
    }else {
      return 0;
    }
  }
 
     goToDetail(type_id, url, type) {
      if (type === 'product') {
        this.router.navigate(['/store/details/', type_id , url]);
      }
    }

     getOrderItems(ono) {
      this.cartService.getOrderDetail(ono)
      .subscribe(
        (x) => {
          this.orderitem = x;
        });
    }
    goForReorder(orderno) {
      this.loading = true;
      this.cquantity = 0;
      this.ordercountflag = this.orderitem.length;
      this.addToCartFromOrderItems();
    }
    addToCartFromOrderItems() {
      this.stockflag = 0;
      for (let i = 0; i < this.orderitem.length; i++) {
        this.productService.getOrderitems(this.orderitem[i].sku, this.orderitem[i].product_name)
        .subscribe((x) => {
          this.addcart(this.orderitem[i].product_name, this.orderitem[i].sku,
            x[i].price, this.orderitem[i].product_id, this.orderitem[i].quantity, x[i].splprice);
        });
      }
    }
    addcart(name: string, sku: string, price: number, id: number, qty, splprice) {
      this.pid = id;
      this.prodname = name;
      this.prodsku = sku;
      this.prodprice = price;
     // this.discount = 0;
     // this.totaldiscount = 0;
     if (splprice === 0) {
      this.discount = 0;
      this.totaldiscount = 0;
      this.payable = price;
    }else {
      this.discount =  price - splprice;
      this.totaldiscount = splprice;
      this.payable = splprice;
    }
      this.checkItems(this.prodsku);
      this.tax = 0 ;
      if (this.flag === 0) {
        this.quantity = qty;
        this.cquantity = qty;
       // this.payable = price * this.quantity;
        this.payable = this.payable * this.quantity;
        this.cartService.createCart(this.pid, this.prodname, this.prodsku, this.prodprice,
          this.discount, this.totaldiscount, this.quantity, this.payable, this.tax, this.uid, this.uname)
        .subscribe(
          (x: Cartitems2[]) => {
            this.ordercountflag = this.ordercountflag - 1;
            this.checkAllFlags();
          });
      } else {
        this.quantity = this.data2[this.cindex].quantity + qty;
        this.cquantity = qty;
        this.payable = (this.data2[this.cindex].mrp - this.data2[this.cindex].discount ) * this.quantity;
        this.cartService.updateCartIfPresent(this.data2[this.cindex].id, this.quantity, this.payable)
        .subscribe(
          (x: Cartitems2[]) => {
            this.ordercountflag = this.ordercountflag - 1;
            this.checkAllFlags();
          });
    }
    }
    checkAllFlags() {
      this.test();
      if (this.ordercountflag === 0) {
        this.loading = false;
        this.goToCart();
      }
    }
    checkItems(sku) {
      this.flag = 0;
          if (this.data2.length > 0) {
            for (let i = 0; i < this.data2.length; i++) {
              if (this.data2[i].sku === sku) {
                this.flag = 1;
                this.cindex = i;
              }
            }
          } else {
            this.flag = 0;
          }
      }
    test() {
      this.cartService.totalcartitems.subscribe(totalcartitems => {
        this.citems = totalcartitems;
      });
      this.cartitemchange();
      this.msg = 'Items Added To Cart';
      this.openSnackBar();
      this.goToCart();
     }
     openSnackBar() {
      this.snackbar.open(this.msg , this.action,{
        duration: 4000,
      });
    }
     cartitemchange() {
      this.citems = this.citems + this.cquantity;
     this.cartService.changeTotalCartItems(this.citems);
    }
    goToCart() {
      this.router.navigate(['/store/cart'])
    }

}
